import { CreatedInterfaces } from 'interfaces';
import { CardHolderType } from 'interfaces/card-holder';
import { useGetRequest } from './utils/useGetRequest';

interface UserInfoParam {
  name?: string;
  lastName?: string;
  identification?: number;
  active?: boolean;
  type?: CardHolderType;
}

const parameterToParamMap = {
  name: 'first_name',
  lastName: 'last_name',
  identification: 'identification_number',
  cardholderId: 'cardholder_id'
};

const resource = 'card-holders';

const useGetAllCardHolders = (pageIndex: number, pageSize: number, userInfo: UserInfoParam, manual?: boolean) => {
  let path = `v2/card_holders?is_active=${userInfo.active ?? true}&size=${pageSize}&page=${pageIndex}&type=${
    userInfo.type || CardHolderType.Person
  }`;

  Object.entries(userInfo).forEach(([param, value]) => {
    if (value && param in parameterToParamMap) {
      path += `&${parameterToParamMap[param]}=${value}`;
    }
  });

  if (userInfo.type === CardHolderType.Company) {
    path = path.replace('first_name', 'legal_name').replace('last_name', 'trade_name');
  }

  const [{ data, error, loading }, execute] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path,
    manual
  });

  return {
    cardHolders: data?.data,
    pageInfo: {
      ...data?.meta,
      total: data?.meta?.total,
    },
    isLoading: loading,
    isError: error,
    execute
  };
};

export default useGetAllCardHolders;
